import { FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AGREEMENT_TYPE } from 'services/templates/agreement-template/types';
import { IChildrenProp } from 'types/components/components.interface';
import {
  IInputProps,
  ISelectOption,
} from 'types/components/inputs/input.interface';
import { useEnumToSelectOptions } from 'utils/components/inputs/select';
import './ContractAgreementDetailWrapper.scss';

interface IContractAgreementDetailWrapperProps
  extends IChildrenProp,
    IInputProps {}

const ContractAgreementDetailWrapper = ({
  children,
  ...props
}: IContractAgreementDetailWrapperProps) => {
  const { setItemAndDetailValue, itemName, displayMode } =
    useFormikContractHelpers();
  const { t } = useTranslation();

  const { getAgreementTypeOptions } = useEnumToSelectOptions();

  const onAgreementTypeChange = (option: ISelectOption, actionMeta: any) => {
    setItemAndDetailValue('content.type', option.value);
  };

  const onTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setItemAndDetailValue<string>(
      `content.textAgreementTemplate.title`,
      event.target.value
    );
    setItemAndDetailValue<string>(
      `content.selectAgreementTemplate.title`,
      event.target.value
    );
    setItemAndDetailValue<string>(
      `content.paragraphAgreementTemplate.title`,
      event.target.value
    );
  };

  return (
    <div className='contract-agreement-detail-wrapper'>
      <FormInput.Text
        {...props}
        onChange={onTitleChange}
        displayMode={displayMode}
      />
      <FormInput.Select
        options={getAgreementTypeOptions(AGREEMENT_TYPE, 'enum.AGREEMENT_TYPE')}
        name={`${itemName}.content.type`}
        onChange={onAgreementTypeChange}
        label={t('input.label.type')}
        displayMode={displayMode}
      />
      {children}
    </div>
  );
};

export default ContractAgreementDetailWrapper;
